/**
 * Canonical constants for the ju credit economy.
 *
 * Mirror the values in:
 *   - supabase/migrations/20260418000007_credits_primitive.sql (DAILY_EARN_CAP)
 *   - supabase/functions/_shared/credits/server-enforce.ts (IMAGE_GEN_COST,
 *     VIDEO_GEN_COST). Note those are server-side gross costs charged by
 *     `text-to-image-v3` / `pollinations-video`. SPEND_COST below is the
 *     CLIENT-side unlock cost (FREE user paying to taste a PRO/MAX model).
 */
export const SHARE_BONUS_AMOUNT = 20;
export const ARENA_SESSION_REWARD = 200;
export const ONBOARDING_AMOUNT = 20;
export const DAILY_EARN_CAP = 500;
/**
 * Canonical spend table — exchange rate for each spendable action.
 * Update here, then update the matching UI copy.
 */
export const SPEND_COST = {
    /** 1 PRO-tier image generation for a FREE user (e.g. Grok Imagine, Qwen Max). */
    IMAGE_UNLOCK_PRO: 1,
    /** 1 MAX-tier image generation. */
    IMAGE_UNLOCK_MAX: 5,
};
/** Default empty balance for anon / new users so UI can render without branching. */
export const EMPTY_BALANCE = {
    creditsAvailable: 0,
    totalEarned: 0,
    totalSpent: 0,
};
